import { render, staticRenderFns } from "./LinkButtons.vue?vue&type=template&id=745c8047&scoped=true"
import script from "./LinkButtons.vue?vue&type=script&lang=js"
export * from "./LinkButtons.vue?vue&type=script&lang=js"
import style0 from "./LinkButtons.vue?vue&type=style&index=0&id=745c8047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c8047",
  null
  
)

export default component.exports